// extracted by mini-css-extract-plugin
export default {"container":"staffs_container__g2SMd","filters":"staffs_filters__Dl6Dc"};